import { render, staticRenderFns } from "./ResetStaffPwd.vue?vue&type=template&id=0145e106&scoped=true"
import script from "./ResetStaffPwd.vue?vue&type=script&lang=js"
export * from "./ResetStaffPwd.vue?vue&type=script&lang=js"
import style0 from "./ResetStaffPwd.vue?vue&type=style&index=0&id=0145e106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0145e106",
  null
  
)

export default component.exports